module.exports = "/_next/static/images/35-1-6f311dcf948765741035856014b4c7f2.jpg";